import { Component, OnInit, inject } from '@angular/core';
import { NgIf } from '@angular/common';

import { PreviewEnvironmentService } from '../../core/services/preview-environment.service';

/**
 * "Preview of review !n — changes here do not affect Development." Shown on every screen (app shell, under the
 * header) while the app runs on a review's preview environment, so nobody mistakes a preview for the real app.
 * CRUD decides what is a preview (`GET environments/preview-status`); see PreviewEnvironmentService.
 */
@Component({
    selector: 'app-preview-environment-banner',
    imports: [NgIf],
    templateUrl: './preview-environment-banner.component.html',
    styleUrl: './preview-environment-banner.component.scss'
})
export class PreviewEnvironmentBannerComponent implements OnInit {
    private readonly previewEnvironment: PreviewEnvironmentService = inject(PreviewEnvironmentService);

    get message(): string | null {
        return this.previewEnvironment.banner;
    }

    ngOnInit(): void {
        void this.previewEnvironment.refreshBanner();
    }
}
